import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Error from '@/components/error'
import Top from '@/components/top'
import StagePhoto from '@/components/digest/stagePhoto'
import TitlePhoto from '@/components/digest/titlePhoto'
import StageThumnail from '@/components/digest/stageThumnail'
import PostPhoto from '@/components/digest/postPhoto'
import CreateStage from '@/components/digest/CreateStage'
import Signin from '@/components/user/Signin'
import AwardsBest from '@/components/awards/awardsBest'
import AwardsEntry from '@/components/awards/awardsEntry'
import AwardsThumnail from '@/components/awards/awardsThumnail'



Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: '/web3/digest2017/',
  
 
  scrollBehavior(to, from, savedPosition) {
		if (to.hash === '#page-top' | to.hash === '#top' ) {
      console.log('to.hash:' + to.hash)
			return { x: 0, y: 0 }
    } 
     else  {
      return { selector: to.hash }
    } 
	},
  routes: [
    {
      path: '/',
      name: 'MyRoot',
      component: Top
    },
    {
      path: '/top',
      name: 'Top',
      component: Top
    },
    
    {
      path: '/best/:id',
      name: 'Best',
      props: true,
      component: AwardsBest
    },
    {
      path: '/thumnail/:id',
      name: 'Thumnail',
      props: true,
      component: AwardsThumnail
    },
    {
      path: '/entry/:id',
      name: 'Entry',
      props: true,
      component: AwardsEntry
    },

    {
      path: '/stageThumnail/:id',
      name: 'StageThumnail',
      props: true,
      component: StageThumnail
    },




    {
      path: '/home',
      name: 'Home',
      component: Home
    },

    {
      path: '/stage',
      name: 'Stage',
      component: StagePhoto
    },
    {
      path: '/title',
      name: 'Title',
      component: TitlePhoto
    },
    {
      path: '/title/:id',
      name: 'TitleId',
      props: true,
      component: TitlePhoto
    },
    {
      path: '/post',
      name: 'Post',
      component: PostPhoto
    },
    {
      path: '/post/:id',
      name: 'PostId',
      props: true,
      component: PostPhoto
    },
    
    // {
    //   path: '/meetup/new',
    //   name: 'CreateMeetup',
    //   component: CreateMeetup,
    //   beforeEnter: AuthGuard
    // },
    {
      path: '/upload',
      name: 'CreateStage',
      component: CreateStage
      // beforeEnter: AuthGuard
    },
    // {
    //   path: '/meetups/:id',
    //   name: 'Meetup',
    //   props: true,
    //   component: Meetup
    // },
    // {
    //   path: '/profile',
    //   name: 'Profile',
    //   component: Profile,
    //   beforeEnter: AuthGuard
    // },
    // {
    //   path: '/signup',
    //   name: 'Signup',
    //   component: Signup
    // },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    }
    ,{
      path: '/error',
      name: 'Error',
      component: Error
    }
    ,{
      path: '*',
      name: 'NotFound',
      component: Error
    }
    

  ],
  
  
})



// WEBPACK FOOTER //
// ./src/router/index.js